import React, { useMemo } from 'react';
import styles from './PurchaseCard.module.scss';
import { PurchaseCardProps } from './PurchaseCard.type.js';
import { PurchaseNav } from './PurchaseTabs/PurchaseNav.js';
import BadgesList from './BadgesList/BadgesList.js';
import { isEveryoneFreeParticipation } from '../../Purchases/List/ListItem/ListItem.js';
import { useIsSomeLotSmp } from '../../Purchases/hooks/useIsSomeLotSmp.js';

const PurchaseCard: React.FC<PurchaseCardProps> = ({
  activeTab,
  announceId,
  canPreviewAnnounce,
  Component,
  purchase,
  reference,
  tabs,
}) => {
  const procedure = purchase?.procedure;
  const customers = purchase.customers;
  const isCommercialOfferVisible = useMemo(() => {
    return purchase.phases.some((phase) =>
      phase.props.find(
        (prop) => prop.name === 'as_commercial_proposal' && prop.value,
      ),
    );
  }, [purchase.phases]);
  const isSomeLotSmp = useIsSomeLotSmp(purchase);

  return (
    <div className={styles.panel}>
      <BadgesList
        customers={customers}
        isCurrentOrgFreeParticipation={isEveryoneFreeParticipation(purchase)}
        procedure={procedure}
        tariff={purchase?.lots?.[0]?.tariff}
        announceNumber={purchase.number}
        isCommercialOfferVisible={isCommercialOfferVisible}
        isSomeLotSmp={isSomeLotSmp}
      />
      <h2>{purchase?.title}</h2>
      <PurchaseNav activeTab={activeTab} tabs={tabs} announceId={announceId} />
      <Component
        canPreviewAnnounce={canPreviewAnnounce}
        purchase={purchase}
        reference={reference}
      />
    </div>
  );
};

export default React.memo(PurchaseCard);
